import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-increase-decrease',
  templateUrl: './increase-decrease.component.html',
  styleUrls: ['./increase-decrease.component.css']
})
export class IncreaseDecreaseComponent implements OnInit, OnDestroy {

  @Input() stepperValue = 2;

  /**
   * Holds the current value of the component
   */
  @Input() modelValue = 0;

  /**
   * Invoked when the model has been component
   */
  @Output() modelValueChange: EventEmitter<number> = new EventEmitter<number>();

  private subscribeModelValueChange = new Subscription();
  constructor() { }

  ngOnInit(): any {
    this.activate();
  }
  ngOnDestroy(): any {
    if (this.subscribeModelValueChange !== undefined) {
      this.subscribeModelValueChange.unsubscribe();
    }
  }
  activate(): any {
  }
  valueChanged(): any {
    this.modelValue = this.stepperValue + this.modelValue;
    this.modelValueChange.emit(this.modelValue);
  }
  increaseValue(): any {
    this.modelValue = this.stepperValue + this.modelValue;
    this.modelValueChange.emit(this.modelValue);
  }
  decreaseValue(): any {
    if (this.modelValue > 0) {
      this.modelValue =  this.modelValue - this.stepperValue;
    } else {
      return;
    }
    this.modelValueChange.emit(this.modelValue);
  }
}
